import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { fetchConToken } from 'helpers/fetch';
import { alertService } from '_services';
import Swal from 'sweetalert2';
import { useUIUtils } from 'hooks/useUIUtils';
import { getDataSession } from 'views/Utils/Common';
import { avisarError, BotonesForma, Campo, cargar, SwitchSN, sucursalActual, Tarjeta } from '../comun';

const AddEdit = ({ history, match }) => {
    const { id } = match.params;
    const isAddMode = !id;
    const { handleSubmit } = useForm();
    const { changeGlobalTitle } = useUIUtils();
    const [usuarios, setUsuarios] = useState([]);
    const [cajeros, setCajeros] = useState([]);
    const [cajas, setCajas] = useState([]);
    const [asignadas, setAsignadas] = useState([]);
    const [asignacion, setAsignacion] = useState({ tipo_Acceso: 'O', caja_Id: '' });
    const [model, setModel] = useState({
        id: 0,
        usuario_Id: '',
        operar_Cajas: 'S',
        abrir_Cajas: 'S',
        reportes_Del_Dia: 'S',
        sucursal_Id: sucursalActual()
    });

    useEffect(() => {
        changeGlobalTitle(isAddMode ? 'Agregar cajero' : 'Editar cajero');
        cargar(`usuarios/GetList?empresa_id=${getDataSession('empresa')}&sucursal_id=${sucursalActual()}&paginas=0&totalXpagina=200&busqueda=`).then(setUsuarios);
        cargar(`pv/PvCajeros/GetList?usuario_id=0&sucursal_id=${sucursalActual()}&paginas=0&totalXpagina=200`).then(setCajeros);
        cargar(`pv/PvCajas/GetList?sucursal_Id=${sucursalActual()}&almacen_id=0&paginas=0&totalXpagina=200&busqueda=`).then(setCajas);
        if (!isAddMode) {
            fetchConToken(`pv/PvCajeros?id=${id}`).then((response) => { if (!avisarError(response)) setModel(response); });
            cargarAsignadas();
        }
    }, [changeGlobalTitle, id, isAddMode]);

    function aplicarAsignacion(lista, cajaPreferida) {
        setAsignadas(lista);
        const actual = cajaPreferida
            ? lista.find((item) => String(item.caja_Id) === String(cajaPreferida)) || lista[0]
            : lista[0];
        if (!actual) {
            setAsignacion({ tipo_Acceso: 'O', caja_Id: '' });
            return;
        }
        setAsignacion({ caja_Id: String(actual.caja_Id), tipo_Acceso: actual.tipo_Acceso || 'O' });
    }

    function cargarAsignadas(cajaPreferida) {
        return cargar(`pv/PvCajeros/Cajas?cajero_id=${id}`).then((lista) => aplicarAsignacion(lista, cajaPreferida));
    }

    function onSubmit() {
        const data = { ...model, usuario_Id: Number(model.usuario_Id), sucursal_Id: Number(sucursalActual()) };
        return fetchConToken('pv/PvCajeros', data, isAddMode ? 'POST' : 'PUT')
            .then((response) => {
                if (avisarError(response)) return false;
                Swal.fire('Exito', 'Guardado', 'success');
                history.push(isAddMode ? '.' : '..');
            })
            .catch(alertService.error);
    }

    function asignarCaja() {
        return fetchConToken('pv/PvCajeros/AsignarCaja', {
            tipo_Acceso: asignacion.tipo_Acceso,
            cajero_Id: Number(id),
            caja_Id: Number(asignacion.caja_Id),
            sucursal_Id: Number(sucursalActual())
        }, 'POST').then((response) => {
            if (avisarError(response)) return;
            Swal.fire('Exito', 'Caja asignada', 'success');
            cargarAsignadas(asignacion.caja_Id);
        }).catch(alertService.error);
    }

    function quitarCaja() {
        return fetchConToken('pv/PvCajeros/EliminarCajaACajero', {
            cajero_Id: Number(id),
            caja_Id: Number(asignacion.caja_Id)
        }, 'POST').then((response) => {
            if (avisarError(response)) return;
            Swal.fire('Exito', 'Caja retirada del cajero', 'success');
            cargarAsignadas();
        }).catch(alertService.error);
    }

    const ocupados = cajeros
        .filter((item) => String(item.id) !== String(id || ''))
        .map((item) => String(item.usuario_Id));
    const usuariosDisponibles = usuarios.filter((item) => !ocupados.includes(String(item.id)));

    const handleInputChange = ({ target }) => setModel({ ...model, [target.name]: target.value });
    const onChangeCheck = ({ target }) => setModel({ ...model, [target.name]: target.checked ? 'S' : 'N' });

    return (
        <div className='container-fluid'>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className='mb-3'><div className='row'><BotonesForma isAddMode={isAddMode} /></div></div>
                <div className='row'>
                    <div className='col-md-6'>
                        <Tarjeta titulo='Cajero'>
                            <Campo label='Usuario'>
                                <select className='form-select' name='usuario_Id' required value={model.usuario_Id || ''} onChange={handleInputChange}>
                                    <option value=''>Seleccione</option>
                                    {usuariosDisponibles.map((item) => <option key={item.id} value={item.id}>{item.nombre}</option>)}
                                </select>
                            </Campo>
                            <SwitchSN name='operar_Cajas' label='Puede operar cajas' checked={model.operar_Cajas} onChange={onChangeCheck} />
                            <div className='espacio15px' />
                            <SwitchSN name='abrir_Cajas' label='Puede abrir cajas' checked={model.abrir_Cajas} onChange={onChangeCheck} />
                            <div className='espacio15px' />
                            <SwitchSN name='reportes_Del_Dia' label='Puede ver reportes del dia' checked={model.reportes_Del_Dia} onChange={onChangeCheck} />
                        </Tarjeta>
                    </div>
                    {!isAddMode && (
                        <div className='col-md-6'>
                            <Tarjeta titulo='Cajas del cajero'>
                                {asignadas.length === 0 ? <p>Sin cajas asignadas</p> : asignadas.map((item) => (
                                    <div key={item.id} className='mb-2'>
                                        {cajas.find((caja) => String(caja.id) === String(item.caja_Id))?.nombre || item.caja_Id}
                                        {': '}
                                        {item.tipo_Acceso === 'C' ? 'Solo consulta' : 'Puede operar la caja'}
                                    </div>
                                ))}
                                <Campo label='Caja'>
                                    <select className='form-select' value={asignacion.caja_Id} onChange={({ target }) => setAsignacion({ ...asignacion, caja_Id: target.value })}>
                                        <option value=''>Seleccione</option>
                                        {cajas.map((item) => <option key={item.id} value={item.id}>{item.nombre}</option>)}
                                    </select>
                                </Campo>
                                <Campo label='Acceso'>
                                    <select className='form-select' value={asignacion.tipo_Acceso} onChange={({ target }) => setAsignacion({ ...asignacion, tipo_Acceso: target.value })}>
                                        <option value='O'>Puede operar la caja</option>
                                        <option value='C'>Solo consulta</option>
                                    </select>
                                </Campo>
                                <button type='button' className='btn btn-outline-primary me-2' disabled={!asignacion.caja_Id} onClick={asignarCaja}>Asignar caja</button>
                                <button type='button' className='btn btn-outline-danger' disabled={!asignacion.caja_Id} onClick={quitarCaja}>Quitar caja</button>
                            </Tarjeta>
                        </div>
                    )}
                </div>
            </form>
        </div>
    );
};

export { AddEdit };
